// 카드결제 베타 초대 팝업 대상 auth user_id(docs/plan-pg-beta-invite.md). 빈 Set = off. 토스 사전검토 통과 셀러만.
// 번들에 포함돼 공개되는 값 — UI 노출만 제어하며 권한을 열지 않는다. 캠페인 on/off는 이 파일만 편집.
// 2026-08-28 1차 웨이브 7곳(안전 순위, 메모리 pg_partnership_track 08-27). 신청 완료 셀러는 여기서 제거(초이·다정다감 08-28). 모집 끝나면 비워서 배포.
// 2026-09-01 모집 종료(빈 Set = off): 신청 6곳(초이·다정다감·우당탕탕오랑이네·지린다옷장·멋지개이쁘개·엘랑)+외부 1 = 총 7곳 대기.
export const PG_BETA_INVITE_USER_IDS: ReadonlySet<string> = new Set<string>([]);
